import AsyncStatus from 'mini-common-schema/lib/schema/AsyncStatus';
import SearchTableQuery from 'mini-mail-list-store/lib/store/schema/SearchTableQuery';
import { get3sSearchResults } from './get3sSearchResults';
import { getExecuteSearchResults } from './getExecuteSearchResults';
import { MailSearchResultsWithSourceInfo } from '../store/schema/MailSearchResults';
import { SearchSourcePreference } from 'mini-search-common/lib/schema/SearchSourcePreference';

/**
 * Returns mail results from requested search source and applies fallback logic if necessary
 * @param searchSourceRequested
 * @param isInitialSearch
 * @param searchTableQuery
 */
export const getMailSearchResults = async (
    searchSourceRequested: SearchSourcePreference,
    isInitialSearch: boolean,
    searchTableQuery: SearchTableQuery
): Promise<MailSearchResultsWithSourceInfo> => {
    const shouldUse3s = searchSourceRequested === SearchSourcePreference.SubstrateSearch;

    let searchResults = shouldUse3s
        ? await get3sSearchResults(searchTableQuery)
        : await getExecuteSearchResults(searchTableQuery);

    const { asyncStatus } = searchResults;

    if (
        (asyncStatus === AsyncStatus.ServerError || asyncStatus === AsyncStatus.Error) &&
        shouldUse3s &&
        isInitialSearch
    ) {
        /*
         * If this is the first search and 3s is being used, then fallback to executeSearch
         * isInitialSearch is to make sure that we don't fallback during loadMore
         */
        searchResults = await getExecuteSearchResults(searchTableQuery);
        /*
         * If even after falling back, we got an error,
         * let the searchSource be 3s
         */
        return {
            ...searchResults,
            searchSource: SearchSourcePreference.LegacySearch,
        };
    } else {
        /**
         * If we got results for what was requested, return the requested results.
         */
        return {
            ...searchResults,
            searchSource: searchSourceRequested,
        };
    }
};
